export default __webpack_public_path__ + "adc7fc48f5738f84da2225b9ab255b76.png";